<script>
  import { ComponentType } from '../../../../../js/constants';
  import { setAccessibilityRedesignRenderState } from '../../../../../js/stores';

  import Toggle from '../../Cart/Toggle/Toggle.svelte';
  import Status from '../../Cart/Status/Status.svelte';
  import Drawer from '../Drawer/Drawer.svelte';
  import NavList from '../NavList/NavList.svelte';

  export let data = {};
  // since Toggle is a child component of Drawer, we need to pass accessibilityRedesignRenderStore as false
  setAccessibilityRedesignRenderState(false);
</script>

<Drawer toggle={Toggle} drawerType="Cart">
  <div class="Cart" data-component-type={ComponentType.MAIN_NAVIGATION}>
    <Status title={data.title} statusZero={data.statusZero} statusOne={data.statusOne} statusMany={data.statusMany} />
    {#if data.primaryNavItems}
      <NavList navItems={data.primaryNavItems} cartPrimary={true} />
    {/if}
    {#if data.secondaryNavItems}
      <NavList navItems={data.secondaryNavItems} />
    {/if}
  </div>
</Drawer>

<style>.Cart {
  --color-theme: #006aff;
  --color-theme-focus: #05c;
}</style>
